module.exports = __webpack_public_path__ + "22b9bdb93cf5e0f42d7f6e46f131697c.woff2";